export default "__VITE_ASSET__BQqi_2lE__"